<app-header class="sticky top-header login-header" [pageName]="'login'"></app-header>

<div class="page-wrap d-flex flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12 text-center">
        <span class="display-1 d-block"> 404</span>
        <div class="mb-4 lead">
          The page you are looking for was not found {{ previousRouteURL ? ': ' + previousRouteURL : '' }}
        </div>
        <div
          class="back-button vert-move"
          (click)="navigateBack()"
          cdkDrag
          (cdkDragStarted)="handleDragStart('back-button', $event)"
          *ngIf="previousRouteURL"
        >
          <span class="icon-Go-back"></span>
          Go Back
        </div>

        <div
          class="back-button vert-move"
          [routerLink]="['/auth/login-ad']"
          cdkDrag
          (cdkDragStarted)="handleDragStart('back-button', $event)"
          *ngIf="!previousRouteURL"
        >
          <span class="icon-Go-back"></span>
          Go Back
        </div>
      </div>
    </div>
  </div>
</div>
